<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  inject: ['setLoading'],
  components: { Vue3ChartJs },
  data() {
    return {
      errors: {},
      title: "Reports",
      text: "Inventory",
      text1: "DC Returns Report",
      filter: {
        from_date: '',
        to_date: '',
        warehouse_id: '',
        status: '',
      },
      summary: {},
      data: [],
      warehouses: [],
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
      docsDetail: {
        show: false,
        documents: [],
        return_dc_number: '',
      },
      itemsDetail: {
        show: false,
        items: [],
        return_dc_number: '',
      },
    };
  },

  computed: {
    serialNo() {
      return (this.pagination.current_page - 1) * this.pagination.per_page;
    },

    statusBarChart() {
      if (!this.summary || !this.summary.status_counts) return null;
      const sc = this.summary.status_counts;
      const labels = [];
      const values = [];
      const statusMap = {
        created: 'Created',
        completed: 'Completed',
      };
      for (const key in sc) {
        if (sc[key] > 0) {
          labels.push(statusMap[key] || key);
          values.push(sc[key]);
        }
      }
      if (!labels.length) return null;
      const colors = ['#f59e0b', '#10b981'];
      return {
        type: 'bar',
        data: {
          labels,
          datasets: [{
            label: 'Returns',
            data: values,
            backgroundColor: labels.map((_, i) => colors[i % colors.length]),
            borderRadius: 6,
            barThickness: 40,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            y: { beginAtZero: true, grid: { color: '#f3f4f6' }, ticks: { stepSize: 1 } },
            x: { grid: { display: false } }
          }
        }
      };
    },

reasonDoughnutChart() {
  if (!this.summary || !this.summary.reason_counts) return null;
  const rc = this.summary.reason_counts;

  // Sort by count descending
  const sorted = Object.entries(rc)
    .filter(([_, v]) => v > 0)
    .sort((a, b) => b[1] - a[1]);

  const TOP_N = 5;
  const top = sorted.slice(0, TOP_N);
  const rest = sorted.slice(TOP_N);

  const labels = top.map(([k]) => k.length > 20 ? k.slice(0, 18) + '…' : k);
  const values = top.map(([_, v]) => v);

  // Baki sab ko "Others" mein merge karo
  if (rest.length > 0) {
    const othersSum = rest.reduce((sum, [_, v]) => sum + v, 0);
    labels.push(`Others (${rest.length})`);
    values.push(othersSum);
  }

  if (!labels.length) return null;

  const colors = ['#4f46e5', '#06b6d4', '#f59e0b', '#10b981', '#ef4444', '#9ca3af'];
  return {
    type: 'doughnut',
    data: {
      labels,
      datasets: [{
        data: values,
        backgroundColor: colors,
        borderWidth: 2,
        hoverOffset: 6,
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { 
          position: 'bottom', 
          labels: { 
            padding: 10, 
            usePointStyle: true, 
            pointStyle: 'circle',
            font: { size: 10 },
            // Label truncate
            generateLabels(chart) {
              const data = chart.data;
              return data.labels.map((label, i) => ({
                text: label.length > 22 ? label.slice(0, 20) + '…' : label,
                fillStyle: data.datasets[0].backgroundColor[i],
                strokeStyle: data.datasets[0].backgroundColor[i],
                pointStyle: 'circle',
                index: i
              }));
            }
          }
        },
        tooltip: {
          callbacks: {
            label(ctx) {
              const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
              const pct = ((ctx.parsed / total) * 100).toFixed(1);
              return ` ${ctx.label}: ${ctx.parsed} (${pct}%)`;
            }
          }
        }
      },
      cutout: '65%',
    }
  };
},
  },

  async mounted() {
    this.getDropdowns();

    const start = moment().subtract(29, "days");
    const end = moment();

    this.filter.from_date = start.format("YYYY-MM-DD");
    this.filter.to_date = end.format("YYYY-MM-DD");

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        autoUpdateInput: false,
        locale: { format: "DD/MM/YYYY", separator: " - ", cancelLabel: "Clear" },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.filter.from_date = start.format("YYYY-MM-DD");
        this.filter.to_date = end.format("YYYY-MM-DD");
        this.$refs.dateRangeInput.value = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
        this.filterReport();
      }
    );

    this.filterReport();
  },

  methods: {

    formatRecipientType(type) {
  if (!type) return '-';
  const map = {
    'App\\Models\\Customer': 'Customer',
    'App\\Models\\Engineer': 'Engineer',
    'App\\Models\\WorkOrder': 'Work Order',
    'App\\Models\\SalesExecutive': 'Sales Executive',
    'App\\Models\\InternalConsumption': 'Internal Consumption',
  };
  return map[type] || type;
},

recipientTypeBadgeClass(type) {
  const map = {
    'App\\Models\\Customer': 'bg-light text-primary border',
    'App\\Models\\Engineer': 'bg-light text-warning border',
    'App\\Models\\WorkOrder': 'bg-light text-success border',
    'App\\Models\\SalesExecutive': 'bg-light text-info border',
    'App\\Models\\InternalConsumption': 'bg-light text-dark border',
  };
  return map[type] || 'bg-light text-dark border';
},

    openDocsDetail(row) {
      this.docsDetail = {
        show: true,
        documents: row.documents || [],
        return_dc_number: row.return_dc_number || '',
      };
    },

    closeDocsDetail() {
      this.docsDetail = { show: false, documents: [], return_dc_number: '' };
    },

    openItemsDetail(row) {
      this.itemsDetail = {
        show: true,
        items: row.return_items || [],
        return_dc_number: row.return_dc_number || '',
      };
    },

    closeItemsDetail() {
      this.itemsDetail = { show: false, items: [], return_dc_number: '' };
    },

    async exportCSV() {
      this.setLoading(true);
      try {
        const payload = { export: 'csv' };
        if (this.filter.from_date) payload.date_from = this.filter.from_date;
        if (this.filter.to_date) payload.date_to = this.filter.to_date;
        if (this.filter.warehouse_id) payload.warehouse_id = this.filter.warehouse_id;
        if (this.filter.status) payload.status = this.filter.status;

        const query_string = new URLSearchParams(payload).toString();
        const response = await axios.get(`/reports/delivery-challan-returns?${query_string}`, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `dc-returns-report-${this.filter.from_date}-to-${this.filter.to_date}.csv`;
        link.click();
        URL.revokeObjectURL(url);
      } catch (error) {
        this.$swalToast('Failed to export CSV', 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async filterReport(page = 1) {
      this.errors = {};
      this.setLoading(true);
      try {
        const payload = {
          page,
          date_from: this.filter.from_date,
          date_to: this.filter.to_date,
        };
        if (this.filter.warehouse_id) payload.warehouse_id = this.filter.warehouse_id;
        if (this.filter.status) payload.status = this.filter.status;

        const query_string = new URLSearchParams(payload).toString();
        const response = await axios.get(`/reports/delivery-challan-returns?${query_string}`);
        this.summary = response.data.data.summary || {};
        this.data = response.data.data.rows.data;
        this.pagination = {
          current_page: response.data.data.rows.current_page,
          per_page: response.data.data.rows.per_page,
          last_page: response.data.data.rows.last_page,
          total: response.data.data.rows.total,
          links: response.data.data.rows.links
        };
      } catch (error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async getDropdowns() {
      try {
        const [warehouseRes] = await Promise.all([
          axios.get('/inventory/warehouses/dropdown'),
        ]);
        this.warehouses = warehouseRes.data.data;
      } catch (error) {
        console.log('Dropdown load error:', error.message);
      }
    },

    changePage(url) {
      if (!url) return;
      const page = new URL(url).searchParams.get("page");
      this.filterReport(page);
    },

    hasActiveFilter() {
      return this.filter.warehouse_id || this.filter.status || this.filter.from_date || this.filter.to_date;
    },

    clearFilter() {
      this.filter.warehouse_id = '';
      this.filter.status = '';
      this.filter.from_date = '';
      this.filter.to_date = '';
      this.$refs.dateRangeInput.value = '';
      this.filterReport();
    },

    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    formatQty(val) {
      const num = parseFloat(val || 0);
      return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
    },

    getTotalReturnQty(row) {
      return (row.return_items || []).reduce((sum, item) => sum + parseFloat(item.return_qty || 0), 0);
    },

    formatStatus(status) {
      if (!status) return '-';
      const map = { created: 'Created', completed: 'Completed' };
      return map[status] || status;
    },

    statusBadgeClass(status) {
      const map = {
        created: 'bg-warning text-dark',
        completed: 'bg-success text-white',
      };
      return map[status] || 'bg-secondary text-white';
    },

    changePctClass(val) {
      const num = parseFloat(val || 0);
      if (num > 0) return 'text-success';
      if (num < 0) return 'text-danger';
      return 'text-muted';
    },

    changePctIcon(val) {
      const num = parseFloat(val || 0);
      if (num > 0) return 'ti ti-trending-up';
      if (num < 0) return 'ti ti-trending-down';
      return 'ti ti-minus';
    },
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <button class="btn btn-outline-primary d-flex align-items-center" @click="exportCSV" :disabled="!data || !data.length">
            <i class="ti ti-file-type-csv me-2"></i>Export CSV
          </button>
        </div>
      </div>

      <!-- Summary Cards -->
      <div class="row g-3 mb-3" v-if="summary && summary.total_return_dcs">
        <div class="col-md-3 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Total Returns</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ summary.total_return_dcs }}</span>
              <span v-if="summary.dc_change_pct != null" :class="changePctClass(summary.dc_change_pct)" style="font-size:11px;">
                <i :class="changePctIcon(summary.dc_change_pct)" style="font-size:12px;"></i> {{ Math.abs(summary.dc_change_pct) }}%
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Total Return Qty</span>
              <span class="fw-bold text-danger" style="font-size:20px;">{{ formatQty(summary.total_return_qty) }}</span>
              <span v-if="summary.qty_change_pct != null" :class="changePctClass(summary.qty_change_pct)" style="font-size:11px;">
                <i :class="changePctIcon(summary.qty_change_pct)" style="font-size:12px;"></i> {{ Math.abs(summary.qty_change_pct) }}%
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Unique Items</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ summary.unique_items }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6">
          <div class="card mb-0 border-0 shadow-sm">
            <div class="card-body p-3 text-center">
              <span class="text-muted d-block" style="font-size:11px;">Unique Warehouses</span>
              <span class="fw-bold text-dark" style="font-size:20px;">{{ summary.unique_warehouses }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6" v-if="summary.condition_counts?.good">
  <div class="card mb-0 border-0 shadow-sm">
    <div class="card-body p-3 text-center">
      <span class="text-muted d-block" style="font-size:11px;">Good Condition</span>
      <span class="fw-bold text-success" style="font-size:20px;">{{ summary.condition_counts.good.count }}</span>
      <span class="d-block text-muted" style="font-size:11px;">{{ formatQty(summary.condition_counts.good.qty) }} qty</span>
    </div>
  </div>
</div>
<div class="col-md-3 col-6" v-if="summary.condition_counts?.faulty">
  <div class="card mb-0 border-0 shadow-sm">
    <div class="card-body p-3 text-center">
      <span class="text-muted d-block" style="font-size:11px;">Faulty Condition</span>
      <span class="fw-bold text-danger" style="font-size:20px;">{{ summary.condition_counts.faulty.count }}</span>
      <span class="d-block text-muted" style="font-size:11px;">{{ formatQty(summary.condition_counts.faulty.qty) }} qty</span>
    </div>
  </div>
</div>
      </div>

      <div class="text-muted text-center mb-2" style="font-size:12px;" v-if="summary.period_from">
      <i class="ti ti-calendar me-1"></i>
      Report Period: {{ formatDate(summary.period_from) }} — {{ formatDate(summary.period_to) }}
    </div>

      <!-- Charts -->
      <div class="row g-3 mb-3" v-if="data && data.length">
        <div class="col-md-6">
          <div class="card mb-0 border-0 shadow-sm" v-if="statusBarChart">
            <div class="card-header border-0 pb-0">
              <h6 class="fw-bold mb-0"><i class="ti ti-chart-bar me-1 text-primary"></i>Returns by Status</h6>
            </div>
            <div class="card-body" style="height:260px;">
              <vue3-chart-js v-bind="statusBarChart" :key="'bar-'+data.length" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card mb-0 border-0 shadow-sm" v-if="reasonDoughnutChart">
            <div class="card-header border-0 pb-0">
              <h6 class="fw-bold mb-0"><i class="ti ti-chart-donut me-1 text-primary"></i>Returns by Reason</h6>
            </div>
            <div class="card-body" style="height:260px;">
              <vue3-chart-js v-bind="reasonDoughnutChart" :key="'reason-'+data.length" />
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card border-0">
        <div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
          <div class="d-flex align-items-center flex-wrap mb-1">
            <div class="me-3" v-if="hasActiveFilter()">
              <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
            </div>
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
                <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
              </div>
            </div>
            <div class="me-3">
              <vue-select
                v-model="filter.warehouse_id"
                :options="warehouses"
                label="name"
                :reduce="w => w.id"
                placeholder="All Warehouses"
                :clearable="true"
                @update:modelValue="filterReport()"
                style="min-width: 180px;"
              ></vue-select>
            </div>
            <div class="me-3">
              <vue-select
                v-model="filter.status"
                :options="[
                  { label: 'Created', value: 'created' },
                  { label: 'Completed', value: 'completed' },
                ]"
                label="label"
                :reduce="s => s.value"
                placeholder="All Status"
                :clearable="true"
                @update:modelValue="filterReport()"
                style="min-width: 180px;"
              ></vue-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-lg-12">
          <div class="card-body card-table-wrapper">
            <div class="custom-datatable-filter table-responsive">
              <table class="card-table" v-if="data && data.length">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Return Date</th>
                    <th>Return DC No.</th>
                    <th>Original Challan</th>
                    <th>Recipient</th>
                    <th>Recipient Type</th>
                    <th>Warehouse</th>
                    <th>Status</th>
                    <th>Return Qty</th>
                    <th>Items</th>
                    <th>Remarks</th>
                    <th>Documents</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in data" :key="row.id">
                    <td>{{ serialNo + index + 1 }}.</td>
                    <td>{{ formatDate(row.return_date) }}</td>
                    <td>
                      <span class="fw-bold text-primary">{{ row.return_dc_number }}</span>
                    </td>
                    <td>
                      <span class="text-dark">{{ row.delivery_challan?.challan_number || '-' }}</span>
                    </td>
                    <td>{{ row.delivery_challan?.recipient_details?.name || '-' }}</td>
                    <td>
                    <span class="badge rounded-pill" :class="recipientTypeBadgeClass(row.delivery_challan?.recipient_type)" style="font-size:10px;">
                      {{ formatRecipientType(row.delivery_challan?.recipient_type) }}
                    </span>
                   </td> 
                    <td>
                      <span class="badge bg-light text-primary border rounded-pill">
                        {{ row.delivery_challan?.warehouse?.name || '-' }}
                      </span>
                    </td>
                    <td>
                      <span class="badge rounded-pill" :class="statusBadgeClass(row.status)">
                        {{ formatStatus(row.status) }}
                      </span>
                    </td>
                    <td>
                      <strong class="text-danger">{{ formatQty(getTotalReturnQty(row)) }}</strong>
                    </td>
                    <td>
                      <button v-if="row.return_items && row.return_items.length"
                        class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                        style="font-size:11px;padding:3px 8px;border-radius:6px;"
                        @click="openItemsDetail(row)">
                        <i class="ti ti-list" style="font-size:13px;"></i> {{ row.return_items.length }} item{{ row.return_items.length > 1 ? 's' : '' }}
                      </button>
                      <span v-else class="text-muted" style="font-size:12px;">-</span>
                    </td>
                    <td>
                      <span style="font-size:12px;" class="text-muted">{{ row.remarks || '-' }}</span>
                    </td>
                    <td>
                      <template v-if="row.documents && row.documents.length === 1">
                        <a :href="row.documents[0].document_url" target="_blank"
                          style="display:inline-flex;align-items:center;gap:4px;padding:3px 8px;border:1px solid #e5e7eb;border-radius:6px;font-size:11px;color:#4f46e5;text-decoration:none;background:#f9fafb;">
                          <i :class="row.documents[0].type && row.documents[0].type.includes('pdf') ? 'ti ti-file-type-pdf' : 'ti ti-photo'"
                            style="font-size:13px;flex-shrink:0;"
                            :style="row.documents[0].type && row.documents[0].type.includes('pdf') ? 'color:#e84040;' : 'color:#6366f1;'"></i>
                          View
                        </a>
                      </template>
                      <template v-else-if="row.documents && row.documents.length > 1">
                        <button class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                          style="font-size:11px;padding:3px 8px;border-radius:6px;"
                          @click="openDocsDetail(row)">
                          <i class="ti ti-paperclip" style="font-size:13px;"></i> {{ row.documents.length }} files
                        </button>
                      </template>
                      <span v-else class="text-muted" style="font-size:12px;">-</span>
                    </td>
                    <td>
                      <span style="font-size:12px;">{{ row.user?.name || '-' }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="p-3 text-center text-muted">No records found.</div>

              <!-- Pagination -->
              <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
                <ul class="pagination pagination-sm">
                  <li v-for="(link, index) in pagination.links" :key="index"
                    :class="['page-item', { active: link.active, disabled: !link.url }]">
                    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
                  </li>
                </ul>
              </nav>

            </div>
          </div>
        </div>
      </div>

    </div>
    <app-footer></app-footer>
  </div>

  <!-- ============ Return Items Detail Modal ============ -->
  <div class="modal fade" :class="{ show: itemsDetail.show }"
    :style="itemsDetail.show ? 'display:block;z-index:1060;' : 'display:none'" tabindex="0">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

        <div class="modal-header" style="padding:14px 18px;border-bottom:1px solid #f0f1f5;background:#f8f9fb;">
          <div style="display:flex;align-items:center;gap:8px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#fee2e2;border-radius:8px;">
              <i class="ti ti-arrow-back-up" style="font-size:15px;color:#ef4444;"></i>
            </span>
            <div>
              <h6 class="fw-bold mb-0" style="font-size:14px;">Returned Items</h6>
              <span class="text-muted" style="font-size:12px;">{{ itemsDetail.return_dc_number }}</span>
            </div>
          </div>
          <button type="button" class="btn-close" @click="closeItemsDetail"></button>
        </div>

        <div class="modal-body" style="padding:16px 18px;">
          <div v-for="item in itemsDetail.items" :key="item.id"
            style="padding:10px 12px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;margin-bottom:8px;">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;">
              <div>
                <span style="font-size:13px;font-weight:500;color:#1a1d23;">{{ item.item?.name || '-' }}</span>
                <span style="font-size:11px;color:#9ca3af;display:block;">Code: {{ item.item?.code || '-' }}</span>
              </div>
              <div style="text-align:right;">
                <span style="font-size:12px;color:#6b7280;">
                  Orig: <strong>{{ formatQty(item.original_qty) }}</strong>
                </span>
                <br>
                <span style="font-size:12px;color:#ef4444;">
                  Returned: <strong>{{ formatQty(item.return_qty) }}</strong>
                </span>
              </div>
            </div>
            <div v-if="item.return_reason" style="margin-top:6px;padding:5px 8px;background:#fff7ed;border-radius:6px;border:1px solid #fed7aa;">
              <span style="font-size:11px;color:#92400e;"><i class="ti ti-info-circle" style="font-size:12px;"></i> {{ item.return_reason }}</span>
            </div>
            <div v-if="item.return_condition" style="margin-top:4px;display:inline-block;">
  <span class="badge rounded-pill" 
    :class="item.return_condition === 'good' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'"
    style="font-size:10px;">
    {{ item.return_condition === 'good' ? 'Good' : 'Faulty' }}
  </span>
</div>
          </div>
        </div>

        <div class="modal-footer" style="padding:10px 18px;border-top:1px solid #f0f1f5;">
          <button type="button" class="btn btn-sm btn-light" @click="closeItemsDetail">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="itemsDetail.show" class="modal-backdrop fade show" style="z-index:1055;" @click="closeItemsDetail"></div>

  <!-- ============ Documents Detail Modal ============ -->
  <div class="modal fade" :class="{ show: docsDetail.show }"
    :style="docsDetail.show ? 'display:block;z-index:1060;' : 'display:none'" tabindex="0">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

        <div class="modal-header" style="padding:14px 18px;border-bottom:1px solid #f0f1f5;background:#f8f9fb;">
          <div style="display:flex;align-items:center;gap:8px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#eef2ff;border-radius:8px;">
              <i class="ti ti-files" style="font-size:15px;color:#4f46e5;"></i>
            </span>
            <div>
              <h6 class="fw-bold mb-0" style="font-size:14px;">Documents</h6>
              <span class="text-muted" style="font-size:12px;">{{ docsDetail.return_dc_number }}</span>
            </div>
          </div>
          <button type="button" class="btn-close" @click="closeDocsDetail"></button>
        </div>

        <div class="modal-body" style="padding:16px 18px;">
          <div v-for="doc in docsDetail.documents" :key="doc.id"
            style="display:flex;align-items:center;justify-content:space-between;padding:10px 12px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;margin-bottom:8px;">
            <div style="display:flex;align-items:center;gap:8px;overflow:hidden;">
              <i :class="doc.type && doc.type.includes('pdf') ? 'ti ti-file-type-pdf' : 'ti ti-photo'"
                style="font-size:20px;flex-shrink:0;"
                :style="doc.type && doc.type.includes('pdf') ? 'color:#e84040;' : 'color:#6366f1;'"></i>
              <span style="font-size:12px;color:#6b7280;">{{ doc.type || 'file' }}</span>
            </div>
            <a :href="doc.document_url" target="_blank"
              style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;background:#eef2ff;border-radius:6px;color:#4f46e5;text-decoration:none;flex-shrink:0;">
              <i class="ti ti-external-link" style="font-size:14px;"></i>
            </a>
          </div>
        </div>

        <div class="modal-footer" style="padding:10px 18px;border-top:1px solid #f0f1f5;">
          <button type="button" class="btn btn-sm btn-light" @click="closeDocsDetail">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="docsDetail.show" class="modal-backdrop fade show" style="z-index:1055;" @click="closeDocsDetail"></div>

</template>

<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>